/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetRoomProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetRoom = ({
  streetName,
  cityName,
}: ContentStreetRoomProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Rooms for rent in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`If you're looking to rent room in ${streetName}, then you've come to the right
            place. A single room for rent in ${streetName} comes with many benefits
            compared to renting an entire flat. With the increasing trend of
            co-living among international students and young professionals, ${streetName}
            room for rent remains the most searched ones on Kamernet. If you are
            looking to rent a room in ${streetName}, then you will find cheap and
            affordable options to choose from. If you don't know where to find a
            room to rent in ${streetName} then look no further, as Kamernet is the best
            website to find rooms near ${streetName} that are affordable and ready to
            move.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography
        variant="h1"
        className={styles.title}
      >{`Kamer te huur in ${streetName}, ${cityName}`}</Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Als je op zoek bent naar een kamer huren in ${streetName}, dan ben je hier aan
            het juiste adres. Kamer te huur in ${streetName} heeft veel voordelen ten
            opzichte van het huren van een hele flat. Met de toenemende trend
            van co-living onder internationale studenten en young professionals,
            studentenkamer in ${streetName} blijft het meest gezocht op Kamernet. Als
            je een kamer wilt huren in ${streetName}, dan vind je goedkope en betaalbare
            opties om uit te kiezen. Als je niet weet waar je een kamer kunt
            vinden in ${streetName} zoek dan niet verder, want Kamernet is de beste
            website om kamers in de buurt van ${streetName} te vinden die betaalbaar en
            instapklaar zijn.`}
      </Typography>
    </React.Fragment>
  );
};
